import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/clientesPotenciales';

export const cargarClientes = async (filtros=null) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = new URLSearchParams();
      if (filtros.nombre && filtros.nombre!=='-1') params.append("nombre", filtros.nombre);
      if (filtros.apellido && filtros.apellido!=='-1') params.append("apellido", filtros.apellido);
      if (filtros.cedula_ruc && filtros.cedula_ruc!=='-1') params.append("cedula_ruc", filtros.cedula_ruc);
      if (filtros.fch_ini_ven && filtros.fch_ini_ven!=='-1'){
        const [year, month, day] = filtros.fch_ini_ven.split('-');
        const formattedDate = `${day}/${month}/${year}`;
        params.append("fecha_desde", formattedDate);
      } 
      if (filtros.fch_fin_ven && filtros.fch_fin_ven!=='-1'){
        const [year, month, day] = filtros.fch_fin_ven.split('-');
        const formattedDate = `${day}/${month}/${year}`;
        params.append("fecha_hasta", formattedDate);
      }
      const response = await fetch(`${API_URL}/listar?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error('Error al listar clientes');
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const obtenerCliente = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/obtener_cliente?id=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Error al obtener el cliente: ${id}`);
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const crearCliente = async (formData, telefonos, correos, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "nombre" : formData.nombre, "apellido" : formData.apellido ,"cedula_ruc" : formData.identificacion, "direccion" : formData.direccion, "fecha_vencimiento": formData.fecha_vencimiento,"telefonos": telefonos, "correos": correos, "creador" : creador, "observaciones": formData.observaciones}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const cambiarCliente = async (formData, editor) => {
  console.log(formData)
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/cambiar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id" : formData.id, "nombre" : formData.nombre ,"cedula_ruc" : formData.identificacion, "editor" : editor}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarCliente = async (formData, editor, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id": id, "nombre" : formData.nombre, "apellido" : formData.apellido ,"cedula_ruc" : formData.identificacion, "fecha_vencimiento": formData.fecha_vencimiento, "direccion" : formData.direccion, "editor" : editor, "observaciones": formData.observaciones}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarCliente = async (id, editor) => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};

export const listarDocumentos = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/listar_documentos?cliente_potencial=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) {
        if (response.status === 404) {
          return [];
        }
      }
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const agregarTelefono = async (formData, id, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "cliente" : id, "telefono" : formData.telefono, "creador" : creador , "descripcion" : formData.descripcion}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarTelefono = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "telefono": formData.telefono, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarTelefono = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarCorreo = async (formData, cliente, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "cliente": cliente, "correo": formData.correo, "creador": creador, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarCorreo = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "correo": formData.correo, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarCorreo = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarDocumento = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_documento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarDocumento = async (formData, cliente, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const body_str = JSON.stringify({ "creador": creador, "tipo": formData.tipo, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido, "cliente_potencial": cliente , "compania": formData.id_compania})    
    const response = await fetch(`${API_URL}/crear_documento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: body_str,
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarDocumento = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_documento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "editor": editor, "id": formData.id, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido, "compania": formData.id_compania }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};